import { render, staticRenderFns } from "./Frage_8.vue?vue&type=template&id=6acb6e53&"
import script from "./Frage_8.vue?vue&type=script&lang=js&"
export * from "./Frage_8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports